import axios from "axios";
const baseUrl = "https://web-production-4245.up.railway.app/";

export const authApi = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

authApi.defaults.headers.common["Content-Type"] = "application/json";

// Axios instance and default configuration

export const refreshAccessTokenFn = async () => {
  const response = await authApi.get("/dj-rest-auth/token/refresh");
  return response.data;
};

authApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const errMessage = error.response.data.errMessage;
    if (errMessage.includes("not logged in") && !originalRequest._retry) {
      originalRequest._retry = true;
      const newToken = await refreshAccessTokenFn();
      authApi.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${newToken.accessToken}`;
      return authApi(originalRequest);
    }
    return Promise.reject(error);
  }
);

export const signUpUserFn = async (
  username,
  email,
  password1,
  password2,
  firstname,
  lastname
) => {
  try {
    const response = await authApi.post(
      "/users/register/",
      username,
      email,
      password1,
      password2,
      firstname,
      lastname
    );
    console.log(response.data);
  } catch (error) {
    console.log(error);
  }
};
export const signInUserFn = async (username, email, password) => {
  try {
    const response = await authApi.post(
      "/users/login/",
      username,
      email,
      password
    );
    console.log(response.data);
  } catch (error) {
    console.log(error);
  }
};

export const signOutUserFn = async () => {
  try {
    const response = await authApi.get("/users/logout/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserFn = async () => {
  try {
    const response = await authApi.get("/users/profile/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const resetPasswordFn = async (email) => {
  try {
    const response = await authApi.post("/users/password-reset/", email);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const resetPasswordConfirmFn = async (
  password1,
  password2,
  uid,
  token
) => {
  try {
    const response = await authApi.post(
      `/users/password-reset-confirm/${uid}/${token}`,
      password1,
      password2,
      uid,
      token
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// API requests to get Projects, ResearchPapers, Events & Techflame
export const getProjectsFn = async () => {
  try {
    const response = await authApi.get("/api-blog/projects/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getProjectDetailsFn = async (id) => {
  try {
    const response = await authApi.get(`/api-blog/projects/${id}/`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getResearchPapersFn = async () => {
  try {
    const response = await authApi.get("/api-blog/researchpapers/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getResearchPaperDetailsFn = async (id) => {
  try {
    const response = await authApi.get(`/api-blog/researchpapers/${id}/`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getTechFlamesFn = async () => {
  try {
    const response = await authApi.get("/api-blog/techflame/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getTechFlameDetailsFn = async (id) => {
  try {
    const response = await authApi.get(`/api-blog/techflame/${id}/`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getEventsFn = async () => {
  try {
    const response = await authApi.get("/api-blog/events/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getEventDetailFn = async (id) => {
  try {
    const response = await authApi.get(`/api-blog/events/${id}/`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const sendContactMessageFn = async (name, email, phone, message) => {
  try {
    const response = await authApi.post("/api-blog/contact/", name, email, phone, message);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};


// Get Cohort details
export const getCohortsFn = async () => {
  try {
    const response = await authApi.get("/teams/cohorts/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
}
